import { render, staticRenderFns } from "./TestSliderSlots.vue?vue&type=template&id=753917f2&"
import script from "./TestSliderSlots.vue?vue&type=script&lang=js&"
export * from "./TestSliderSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports